export const MAX_TITLE_LENGTH = 500;
export const MAX_HEADLINE_LENGTH = 500;
export const MAX_SUMMARY_LENGTH = 500;
export const MAX_DESCRIPTION_LENGTH = 1959;

export const audiences = [
  // { label: "Is Active", name: "Active" },
  { label: "TMC User", name: "TMCUsers" },
  { label: "TI User", name: "TIUsers" },
  { label: "Guest Users", name: "GuestUsers" },
  { label: "Registered Users", name: "LoggedInUsers" },
  { label: "Both registered & guest users", name: "AllUsers" },
  { label: "Users with Upcoming Renewals", name: "Renewals" },
  { label: "Match All Audiences", name: "MatchAll" },
  { label: "Signed up to Marketing?", name: "Marketing" },
];
